(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ishi_single_product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-gifting-campaign"] && !Shopify.designMode) return;
  try {
    
function initCorporate(root){
  if(!root || root.dataset.initialized) return;
  root.dataset.initialized='true';

  const sessionGet=(key)=>{
    try{return window.sessionStorage.getItem(key);}catch(e){return null;}
  };
  const sessionSet=(key,value)=>{
    try{window.sessionStorage.setItem(key,value);}catch(e){}
  };
  const sessionRemove=(key)=>{
    try{window.sessionStorage.removeItem(key);}catch(e){}
  };

  const attribution={};
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key=>{
    let value='';
    try{
      const current=new URLSearchParams(window.location.search).get(key);
      if(current){
        value=current;
        sessionSet('ns_corp_'+key,current);
      }else{
        value=sessionGet('ns_corp_'+key)||'';
      }
    }catch(e){}
    if(value) attribution[key]=value;
  });

  const metaParams=(extra={})=>Object.assign({
    content_category:'Corporate Gifting',
    page_path:window.location.pathname
  },attribution,extra);

  const sendMeta=(method,eventName,params={})=>{
    let attempts=0;
    const fire=()=>{
      if(typeof window.fbq==='function'){
        window.fbq(method,eventName,params);
        return;
      }
      if(attempts<20){
        attempts+=1;
        window.setTimeout(fire,250);
      }
    };
    fire();
  };

  if(!window.__nsCorporateLandingViewTracked){
    window.__nsCorporateLandingViewTracked=true;
    sendMeta('trackCustom','CorporateLandingView',metaParams({
      content_name:'Corporate Gifting Landing Page'
    }));
  }

  root.querySelectorAll('[data-cg-product]').forEach(link=>{
    link.addEventListener('click',()=>{
      const productName=link.dataset.cgProduct||'';
      const field=root.querySelector('#cg-product');
      if(field){
        field.value=productName;
        field.dispatchEvent(new Event('change',{bubbles:true}));
      }
      sendMeta('trackCustom','ProductInterest',metaParams({
        product_name:productName,
        cta_location:'electric_diffusers'
      }));
    });
  });

  root.querySelectorAll('a[href="#cg-enquiry"]:not([data-cg-product])').forEach(link=>{
    link.addEventListener('click',()=>{
      let location='other';
      if(link.closest('.cg-hero')) location='hero';
      else if(link.closest('.cg-header')) location='header';
      else if(link.closest('.cg-gifting')) location='gifting_section';
      else if(link.closest('.cg-sticky')) location='mobile_sticky';
      sendMeta('trackCustom','CorporateCTA_Click',metaParams({
        cta_location:location
      }));
    });
  });

  root.querySelectorAll('a[href="#cg-collection"]').forEach(link=>{
    link.addEventListener('click',()=>{
      const location=link.closest('.cg-header')?'header':'hero';
      sendMeta('trackCustom','ExploreCollection_Click',metaParams({
        cta_location:location
      }));
    });
  });

  root.querySelectorAll('.cg-occasion-link').forEach(link=>{
    link.addEventListener('click',()=>{
      const card=link.closest('.cg-occasion-card');
      const title=card?.querySelector('h3')?.textContent?.trim()||'';
      sendMeta('trackCustom','Bestseller_Click',metaParams({
        content_name:title,
        destination_url:link.href,
        section:'who_we_serve'
      }));
    });
  });

  const contactForm=root.querySelector('#CorporateGiftingContact');
  if(contactForm){
    const markFormStart=()=>{
      if(contactForm.dataset.metaFormStarted) return;
      contactForm.dataset.metaFormStarted='true';
      sendMeta('trackCustom','FormStart',metaParams({
        form_name:'Corporate Gifting Enquiry'
      }));
    };
    contactForm.addEventListener('focusin',markFormStart);
    contactForm.addEventListener('input',markFormStart);
    contactForm.addEventListener('submit',()=>{
      sessionSet('nsCorporateLeadPendingToken',String(Date.now()));
    });
  }

  if(!window.__nsCorporateWhatsappTrackingBound){
    window.__nsCorporateWhatsappTrackingBound=true;
    document.addEventListener('click',event=>{
      const source=event.target instanceof Element ? event.target : event.target?.parentElement;
      const link=source?.closest?.('a[href*="wa.me"],a[href*="whatsapp.com"]');
      if(!link || !document.querySelector('.cg')) return;

      let location='whatsapp_widget_or_other';
      if(link.closest('.cg-enquiry')) location='enquiry_section';
      else if(link.closest('.cg-sticky')) location='mobile_sticky';

      sendMeta('track','Contact',metaParams({
        contact_method:'whatsapp',
        cta_location:location
      }));
    });
  }

  root.querySelectorAll('.cg-review-card').forEach(card=>{
    const video=card.querySelector('.cg-review-video');
    const toggle=card.querySelector('.cg-review-toggle');
    if(!video || !toggle) return;

    const setPausedState=()=>{
      card.classList.remove('is-playing');
      toggle.setAttribute('aria-label','Play '+(video.getAttribute('aria-label')||'video'));
    };

    const setPlayingState=()=>{
      card.classList.add('is-playing');
      toggle.setAttribute('aria-label','Pause '+(video.getAttribute('aria-label')||'video'));
      if(!card.dataset.metaPlayed){
        card.dataset.metaPlayed='true';
        sendMeta('trackCustom','ClientVideoPlay',metaParams({
          video_name:video.getAttribute('aria-label')||'Client testimonial'
        }));
      }
    };

    toggle.addEventListener('click',()=>{
      if(video.paused){
        root.querySelectorAll('.cg-review-card').forEach(otherCard=>{
          if(otherCard===card) return;
          const otherVideo=otherCard.querySelector('.cg-review-video');
          if(otherVideo && !otherVideo.paused) otherVideo.pause();
          otherCard.classList.remove('is-playing');
          const otherToggle=otherCard.querySelector('.cg-review-toggle');
          if(otherToggle){
            otherToggle.setAttribute('aria-label','Play '+(otherVideo?.getAttribute('aria-label')||'video'));
          }
        });
        video.play();
      }else{
        video.pause();
      }
    });

    video.addEventListener('play',setPlayingState);
    video.addEventListener('pause',setPausedState);
    video.addEventListener('ended',()=>{
      try{video.currentTime=0;}catch(e){}
      setPausedState();
    });
  });

  const mobileHeroVideo=root.querySelector('.cg-mobile-hero-video-el');
  if(mobileHeroVideo){
    const mobileQuery=window.matchMedia('(max-width: 760px)');
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const soundToggle=root.querySelector('.cg-hero-sound');
    const soundLabel=soundToggle?.querySelector('.cg-hero-sound-label');
    let soundExplicitlyChosen=false;
    let interactionSoundArmed=false;

    const syncSoundState=()=>{
      if(!soundToggle) return;
      const soundOn=!mobileHeroVideo.muted;
      soundToggle.classList.toggle('is-on',soundOn);
      soundToggle.setAttribute('aria-pressed',soundOn?'true':'false');
      soundToggle.setAttribute('aria-label',soundOn?'Turn hero sound off':'Turn hero sound on');
      if(soundLabel) soundLabel.textContent=soundOn?'SOUND ON':'SOUND OFF';
    };

    const removeInteractionSoundListeners=()=>{
      if(!interactionSoundArmed) return;
      interactionSoundArmed=false;
      document.removeEventListener('pointerdown',enableSoundFromFirstInteraction,true);
      document.removeEventListener('touchstart',enableSoundFromFirstInteraction,true);
      document.removeEventListener('keydown',enableSoundFromFirstInteraction,true);
    };

    const enableSound=async()=>{
      if(!mobileQuery.matches || reduceMotion.matches) return false;
      mobileHeroVideo.volume=1;
      mobileHeroVideo.muted=false;
      try{
        await mobileHeroVideo.play();
        syncSoundState();
        return true;
      }catch(error){
        mobileHeroVideo.muted=true;
        syncSoundState();
        return false;
      }
    };

    async function enableSoundFromFirstInteraction(event){
      if(soundExplicitlyChosen) return;
      if(event?.target?.closest?.('.cg-hero-sound')) return;
      const enabled=await enableSound();
      if(enabled) removeInteractionSoundListeners();
    }

    const armSoundOnFirstInteraction=()=>{
      if(interactionSoundArmed || soundExplicitlyChosen || !mobileQuery.matches || reduceMotion.matches) return;
      interactionSoundArmed=true;
      document.addEventListener('pointerdown',enableSoundFromFirstInteraction,true);
      document.addEventListener('touchstart',enableSoundFromFirstInteraction,true,{passive:true,capture:true});
      document.addEventListener('keydown',enableSoundFromFirstInteraction,true);
    };

    const startMobileHero=async()=>{
      if(!mobileQuery.matches || reduceMotion.matches){
        removeInteractionSoundListeners();
        mobileHeroVideo.pause();
        return;
      }

      /*
       * Browsers commonly block audible autoplay. Start muted and stable so the
       * interface never flashes SOUND ON before the browser revokes audio.
       * The first genuine user interaction unlocks audio automatically.
       */
      mobileHeroVideo.muted=true;
      syncSoundState();
      try{ await mobileHeroVideo.play(); }catch(e){}
      armSoundOnFirstInteraction();
    };

    startMobileHero();
    if(typeof mobileQuery.addEventListener==='function') mobileQuery.addEventListener('change',startMobileHero);
    if(typeof reduceMotion.addEventListener==='function') reduceMotion.addEventListener('change',startMobileHero);

    if(soundToggle){
      syncSoundState();
      soundToggle.addEventListener('click',async()=>{
        soundExplicitlyChosen=true;
        removeInteractionSoundListeners();
        if(mobileHeroVideo.muted){
          await enableSound();
        }else{
          mobileHeroVideo.muted=true;
          syncSoundState();
        }
      });
    }
  }

  const sticky=root.querySelector('.cg-sticky');
  const form=root.querySelector('#cg-enquiry');
  if(sticky && form && 'IntersectionObserver' in window){
    new IntersectionObserver(entries=>{
      sticky.classList.toggle('is-hidden',entries[0].isIntersecting);
    },{threshold:0}).observe(form);
  }

  const header=root.querySelector('.cg-header');
  if(header && !header.dataset.scrollBound){
    header.dataset.scrollBound='true';
    const syncCorporateHeader=()=>{
      header.classList.toggle('is-scrolled',window.scrollY>12);
    };
    syncCorporateHeader();
    window.addEventListener('scroll',syncCorporateHeader,{passive:true});
  }

  const success=root.querySelector('.cg-success');
  if(success){
    const pendingToken=sessionGet('nsCorporateLeadPendingToken');
    const firedToken=sessionGet('nsCorporateLeadFiredToken');
    if(pendingToken && pendingToken!==firedToken){
      sendMeta('track','Lead',metaParams({
        content_name:'Corporate Gifting Enquiry'
      }));
      sessionSet('nsCorporateLeadFiredToken',pendingToken);
      sessionRemove('nsCorporateLeadPendingToken');
    }
    success.focus();
    success.scrollIntoView({block:'center'});
  }
}
document.querySelectorAll('.cg').forEach(initCorporate);
document.addEventListener('shopify:section:load',event=>{
  event.target.querySelectorAll('.cg').forEach(initCorporate);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
